// third-party
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import userReducer from './slices/user';
import menuReducer from './slices/menu';
import sysUser from './slices/sysuser';
import topic from './slices/topic';
import argument from './slices/argument';
import company from './slices/company';
import room from './slices/room';
import sysGroupReducer from './slices/sysgroup';
import location from "./slices/location";
import guardian from "./slices/guardian";
import student from "./slices/student";
import teacher from "./slices/teacher";
import service from "./slices/service";
import firm from "./slices/firm";
import member from "./slices/member";
import registration from "./slices/registration";
import recharge from "./slices/recharge";
import platfond from "./slices/platfond";
import activity from "./slices/activites";
import transaction from "./slices/transaction";
import dashboard from "./slices/dashboard";
import archive from "./slices/archive";
import loadingReducer from "./slices/loading";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    user: userReducer,
    menu: menuReducer,
    sysUser: sysUser.reducer,
    topic: topic.reducer,
    argument: argument.reducer,
    sysGroup: sysGroupReducer,
    company: company.reducer,
    room: room.reducer,
    location: location.reducer,
    guardian: guardian.reducer,
    student: student.reducer,
    teacher: teacher.reducer,
    service: service.reducer,
    firm: firm.reducer,
    member: member.reducer,
    registration: registration.reducer,
    recharge: recharge.reducer,
    platfond: platfond.reducer,
    activity: activity.reducer,
    transaction: transaction.reducer,
    dashboard: dashboard.reducer,
    archive: archive.reducer,
    loading: loadingReducer,
});

export default reducer;